var _style, _g, _path, _g2, _g3, _path2, _path3, _path4, _path5, _path6, _path7, _g4, _g5, _g6, _g7, _g8;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAllianz = function SvgAllianz(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 370 200",
    style: {
      enableBackground: "new 0 0 370 200"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#003D46;}\n\t.st2{fill:#D5EEEF;}\n\t.st3{fill:#B7E4F3;}\n\t.st4{fill:#FFFFFF;}\n\t.st5{fill:#223E7C;}\n\t.st6{fill:#010101;}\n\t.st7{fill:url(#SVGID_1_);}\n\t.st8{fill:url(#SVGID_2_);}\n\t.st9{fill:#A97C50;}\n\t.st10{fill:#2DBCAE;}\n\t.st11{fill:#083141;}\n\t.st12{fill:#113748;}\n\t.st13{fill:#BEE7FB;}\n\t.st14{opacity:0.2;fill:url(#SVGID_4_);enable-background:new    ;}\n")), /*#__PURE__*/React.createElement("pattern", {
    y: 200,
    width: 19,
    height: 19,
    patternUnits: "userSpaceOnUse",
    id: "SVGID_3_",
    viewBox: "0 -19 19 19",
    style: {
      overflow: "visible"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: -19,
    className: "st0",
    width: 19,
    height: 19
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: -19,
    className: "st0",
    width: 19,
    height: 19
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.8,0L0-15.8v1.6L14.2,0H15.8z M9.5,0L0-9.5v4.7L4.7,0H9.5z M19-9.5L9.5-19H4.7L19-4.8V-9.5z M19-14.3 v-1.6L15.8-19h-1.6L19-14.3z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  }, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M358.8,188.6c-2.1,3.9-4.6,7.7-7.6,11H44.8c-2.4-2.5-4.6-5.4-6.6-8.6c-2.8-4.3-5.4-8.5-7.6-13.2 c-15.9-33.3-6.1-80.8,36.3-87c15.6-2.4,31.9-1.5,46.8-7.1c19.8-7.4,26.3-25.6,39-40.6c9.3-11,21.9-19.8,36-23.3 c26.2-6.6,52.9,7.4,67.7,28.9c7.7,11.2,13.6,23.6,21.8,34.5c22.5,30.1,87.2,26.5,89.2,72C367.9,166.7,364.4,178.4,358.8,188.6z"
  })), /*#__PURE__*/React.createElement("g", null, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M320.1,199.3l-96.4-0.2c-4.9,0-8.8-4-8.8-8.8l0.2-140.9c0-4.9,4-8.8,8.8-8.8l96.4,0.2 c4.9,0,8.8,4,8.8,8.8L329,190.5C329,195.4,325,199.3,320.1,199.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M317.2,191.8l-90.6-0.2c-2.9,0-5.2-2.3-5.2-5.2l0.2-133c0-2.9,2.3-5.2,5.2-5.2l90.6,0.2 c2.9,0,5.2,2.3,5.2,5.2l-0.2,133C322.5,189.5,320.1,191.8,317.2,191.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M301.6,39.8v4.9l-58.1-0.1v-4.9c0-4.2,3.4-7.7,7.7-7.7h16.5v0.1c0,2.7,2.2,4.9,4.8,4.9 c2.7,0,4.9-2.2,4.9-4.8v-0.1h16.5C298.1,32.1,301.6,35.6,301.6,39.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M272.5,22c-5.6,0-10.1,4.5-10.2,10v0.1c0,5.6,4.5,10.2,10.1,10.2s10.2-4.5,10.2-10.1v-0.1 C282.6,26.5,278.1,22,272.5,22z M272.5,37c-2.7,0-4.9-2.2-4.8-4.9V32c0.1-2.6,2.2-4.7,4.9-4.7c2.6,0,4.8,2.1,4.8,4.8v0.1 C277.4,34.9,275.2,37,272.5,37z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 270.5,
    y: 13.6,
    transform: "matrix(1.707055e-03 -1 1 1.707055e-03 229.487 315.1075)",
    className: "st5",
    width: 4.2,
    height: 58.1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M244.5,112.2h-11.9c-0.9,0-1.6-0.7-1.6-1.6V98.7c0-0.9,0.7-1.6,1.6-1.6h11.9c0.9,0,1.6,0.7,1.6,1.6v11.9 C246.1,111.5,245.4,112.2,244.5,112.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M310.2,103.3l-51.5-0.1c-1.7,0-3-1.4-3-3l0,0c0-1.7,1.4-3,3-3l51.5,0.1c1.7,0,3,1.4,3,3l0,0 C313.2,101.9,311.8,103.3,310.2,103.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M289.7,111.8l-31-0.1c-1.7,0-3-1.4-3-3l0,0c0-1.7,1.4-3,3-3l31,0.1c1.7,0,3,1.4,3,3l0,0 C292.7,110.5,291.4,111.8,289.7,111.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M244.5,143h-11.9c-0.9,0-1.6-0.7-1.6-1.6v-11.9c0-0.9,0.7-1.6,1.6-1.6h11.9c0.9,0,1.6,0.7,1.6,1.6v11.9 C246.1,142.2,245.4,143,244.5,143z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M310.1,134l-51.5-0.1c-1.7,0-3-1.4-3-3l0,0c0-1.7,1.4-3,3-3l51.5,0.1c1.7,0,3,1.4,3,3l0,0 C313.1,132.7,311.8,134,310.1,134z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M289.6,142.5l-31-0.1c-1.7,0-3-1.4-3-3l0,0c0-1.7,1.4-3,3-3l31,0.1c1.7,0,3,1.4,3,3l0,0 C292.7,141.2,291.3,142.5,289.6,142.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M244.4,173.7h-11.9c-0.9,0-1.6-0.7-1.6-1.6v-11.9c0-0.9,0.7-1.6,1.6-1.6h11.9c0.9,0,1.6,0.7,1.6,1.6 v11.9C246,173,245.3,173.7,244.4,173.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M310.1,164.8l-51.5-0.1c-1.7,0-3-1.4-3-3l0,0c0-1.7,1.4-3,3-3l51.5,0.1c1.7,0,3,1.4,3,3l0,0 C313.1,163.4,311.7,164.8,310.1,164.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M289.6,173.3l-31-0.1c-1.7,0-3-1.4-3-3l0,0c0-1.7,1.4-3,3-3l31,0.1c1.7,0,3,1.4,3,3l0,0 C292.6,171.9,291.3,173.3,289.6,173.3z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M238,110.3l-7.3-5.6c-0.6-0.4-0.7-1.2-0.2-1.8l0,0c0.4-0.6,1.2-0.7,1.8-0.2l5.5,4.2l8.2-9 c0.5-0.5,1.3-0.6,1.8-0.1l0,0c0.5,0.5,0.6,1.3,0.1,1.8L238,110.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M238,141.4l-7.3-5.6c-0.6-0.4-0.7-1.2-0.2-1.8l0,0c0.4-0.6,1.2-0.7,1.8-0.2l5.5,4.2l8.2-9 c0.5-0.5,1.3-0.6,1.8-0.1l0,0c0.5,0.5,0.6,1.3,0.1,1.8L238,141.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M238,171.4l-7.3-5.6c-0.6-0.4-0.7-1.2-0.2-1.8l0,0c0.4-0.6,1.2-0.7,1.8-0.2l5.5,4.2l8.2-9 c0.5-0.5,1.3-0.6,1.8-0.1l0,0c0.5,0.5,0.6,1.3,0.1,1.8L238,171.4z"
  })))), /*#__PURE__*/React.createElement("g", null, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 110.2,
    y: 2.4,
    className: "st6",
    width: 1.5,
    height: 179.7
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M111,15.8L111,15.8c-1.2,0-2.2-1-2.2-2.2V3.1c0-1.2,1-2.2,2.2-2.2l0,0c1.2,0,2.2,1,2.2,2.2v10.5 C113.1,14.8,112.2,15.8,111,15.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 106.3887,
    y1: 172.6765,
    x2: 71.7854,
    y2: 133.8788,
    gradientTransform: "matrix(1 0 0 -1 0 200)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#52C8EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9852,
    style: {
      stopColor: "#86D4EE"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M110.8,10.2c-0.5,0.7-17.1,24.6-20.2,65.3l0,0c-5.3-6.2-12.8-9.4-20.3-9.4s-15,3.1-20.3,9.4 C62.1,25.9,110,10.5,110.8,10.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 156.044,
    y1: 136.9332,
    x2: 115.8483,
    y2: 161.575,
    gradientTransform: "matrix(1 0 0 -1 0 200)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0147783,
    style: {
      stopColor: "#86D4EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#52C8EA"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M111,10.2c0.7,0.2,48.7,15.6,60.8,65.3c-10.6-12.5-30-12.5-40.6,0C128.1,34.8,111.5,11,111,10.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M110.8,10.2c-0.7,0.2-48.7,15.6-60.8,65.3l0,0l0,0C39.3,63.1,20.1,63,9.5,75.3 C27.1,37,65.8,10.3,110.8,10.2L110.8,10.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M111,10.2c0.5,0.7,17.1,24.6,20.2,65.3l0,0c-5.3-6.2-12.8-9.4-20.3-9.4s-15,3.1-20.3,9.4 c3.1-40.7,19.7-64.5,20.2-65.3l0,0C110.8,10.2,110.9,10.2,111,10.2C110.9,10.2,110.9,10.2,111,10.2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M171.8,75.5L171.8,75.5L171.8,75.5c-12.2-49.6-60.1-65-60.9-65.2l0,0c45,0,83.9,26.7,101.5,65.1v0.2l0,0 C201.8,63,182.5,63,171.8,75.5z"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M344.3,88.5v6.1c0,0-1.3,0.8-4.3,0.8c-1.6,0-2-0.8-2-0.8v-2.3L344.3,88.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M345.1,83.9c0,0.2,0,0.4,0,0.6c0,0.1,0,0.1,0,0.2c0.1,3.6-2.2,7.5-5.7,8c0,0,0,0-0.1,0h-0.1 c-0.8,0.1-3.5,0.3-4.5-0.8c-1.2-1.3-2.2-3.6-2.2-5.3c0-1.6,0.3-2,0.3-2.6c0-0.5-0.3-2.1-0.3-2.8c0-3.2,2.2-6.5,6-6.5 C344.3,74.9,345.2,80,345.1,83.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M338,94.4"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M358.7,118.8c-1.9,0.8-7.5-9.9-9.6-14.6s-2.8-8.8-0.5-9.7c2.3-1,4.7,2.5,6.5,7.2 C357,106.5,360.6,118,358.7,118.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M347.9,138.5c-1.7-0.8,3.5-13.2,5.1-16.7s3.5-7,5.4-6.1s0.4,4.6-1.1,8.1 C355.7,127.2,349.6,139.2,347.9,138.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M349.3,135.3c2,0.8,0.3,4.2-0.3,5.3c-1,1.9-3.9,2.8-4.7,2.4c-0.7-0.4,1.9-4.4,1.8-4.7 c-0.1-0.2-1.3,2.1-2,1.6c-0.6-0.4,1-3.2,2-4C347.3,135.1,348,134.8,349.3,135.3z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M338.9,131.7c1.9,0.1,3.6,2.6,3.8,5.2c0.1,2.1,0.1,4.9-0.4,8.4c-1.3,8.5-1.1,19.4-3.6,20.1 c-2.5,0.7-5.2-5.3-5.1-14.1c0.1-8-0.8-18.2,0.9-19.2C335.4,131.6,337.3,131.6,338.9,131.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M336.7,163.3c7.1-2.2,3.9,22.9,1.5,29s-3.3-0.9-3.7-11.4C334,170.3,333.9,164.1,336.7,163.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M348.1,131.7c1.9,0.1,3.6,2.6,3.8,5.2c0.1,2.1,0.1,4.9-0.4,8.4c-1.3,8.5-1.1,19.4-3.6,20.1 c-2.5,0.7-5.2-5.3-5.1-14.1c0.1-8-0.8-18.2,0.9-19.2C344.6,131.6,346.5,131.6,348.1,131.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M345.9,163.3c7.1-2.2,3.9,22.9,1.5,29s-3.3-0.9-3.7-11.4C343.2,170.3,343.1,164.1,345.9,163.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M333.6,95.1c-1.2,1.1-2.2,3.2-2.4,7.3c-0.1,1.1-0.9,4.3,0.6,8.1c2.4,5.9,0,18.2-0.6,21.1 c-0.1,0.3,0.2,0.6,0.5,0.6l20.5,0.4c0.6,0,1.1-0.5,1-1.1c-0.3-4.1-1.4-18.1-0.9-21.5c1.9-11.9,0-15.7-3.3-16.6 C344,92,334.8,93.9,333.6,95.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "342.9,145.6 343.7,180.8 349.6,180.7 351.2,146  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "333.7,145.6 334.6,180.8 340.5,180.7 342,146  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M353.1,131.9l0.7,31.8c0,0-8.7,1.1-11.6,1c-5.2-0.1-11.4-0.9-11.4-0.9l0.7-32.1L353.1,131.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M311.3,103.5c1.2-1.4,11.6,7.1,14.4,9.6s5.6,5.3,4.3,6.9c-1.3,1.5-4.5-0.9-7.4-3.4 C319.8,114.1,310.1,104.9,311.3,103.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M329,120.4c-2-0.5-0.1-12.3,1.1-17.3c1.2-4.9,3-8.6,5.4-8s2.2,4.7,0.9,9.6 C335.1,109.7,331,120.9,329,120.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M307.6,99.4c0.5-0.5,3.1,2,3.9,2.7c0.1,0.1,0.2,0.2,0.2,0.2s0,0,0-0.1c-0.1-0.4-1.2-1.8-0.7-2.3 s2.6,1.4,3.3,2.7c0,0.1,0.1,0.1,0.1,0.2c0.6,1.2,0.7,2-0.1,3.1c-1.2,1.8-4.1-0.7-5.1-1.6c-0.8-0.7-1.4-1.9-1.7-2.8 C307.4,100.5,307.3,99.7,307.6,99.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M331.4,79.4c0,0.2,0.1,0.4,0.1,0.6c0.2,0.9,0.8,1.6,1.1,2.4c0.4,1,0.5,2,0.6,3.1c0.4,2.5,0.7,5,0.9,7.5 c0.1,1.9-0.3,3.7,0.4,5.5c0.9,2.4,2.7,5.1,4.5,6.9c1.7,1.6,3.8,2.5,6.1,2.3c2.6-0.3,5.1-1.9,6.4-4.2c1.3-2.3,2-5,1.8-7.7 c-0.3-3.7-2-7.2-4.4-10.2c-0.8-1-1.7-2-2.2-3.2c-0.6-1.3-0.4-2.8-0.7-4.2c-0.4-1.4-1.1-2.6-2.3-3.4c-2.3-1.6-5.4-1.4-7.9-0.6 C333.3,75,331,76.5,331.4,79.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M335.3,192.2c0,0-1,1.1-3.3,2.5s-2.9,1.1-2.9,1.7c-0.1,0.5,9.5,0.1,9.5,0.1l-0.1-4.4 C338.4,192,335.3,192,335.3,192.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M344.6,192.1c0,0-0.5,1.3-2.1,2.8c-1.4,1.3-1.9,1-1.8,1.5s7,0.2,7,0.2l-0.2-4.6 C347.5,192,344.6,192,344.6,192.1z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M69.7,147.2L69.7,147.2c0.1,0,1.8-0.3,3.4-1.2l0,0v2.4c0,0-0.5,2.3-3.3,2.9c-2.8-0.6-3.3-2.9-3.3-2.9 v-2.2l0,0C68.2,147,69.7,147.2,69.7,147.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M69.8,147.2L69.8,147.2c-0.1,0-1.6-0.2-3.1-1c-1.5-0.7-3-2-3.3-4c0,0-1.7-0.7-1.7-2.1c0-1.4,1.5-1,1.5-1 s-1.2-4.4,1.1-7.6c2.3-3.3,5.3-2.2,5.3-2.2h0.2c0,0,3-1,5.3,2.2s1.1,7.6,1.1,7.6s1.5-0.4,1.5,1s-1.7,2.1-1.7,2.1 c-0.3,1.9-1.6,3.1-3,3.8C71.5,147,69.8,147.2,69.8,147.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M84.1,182.1L84.1,182.1c-6.6,2.7-13.6,6.9-14.2,7.3c-0.6-0.4-7.6-4.6-14.2-7.2v-0.1v-6.2v-3.6h1.5h12.6 H70h12.6h1.5v3.6V182.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M55.7,182.1L55.7,182.1c-1.3-0.4-2.5-0.8-3.7-1.2c-3-2.4-7.1-5.9-7.5-7.5c-0.4-1.2,1.2-4.7,3.3-8.5l0,0 l6.7,3.8c-0.9,1.6-1.7,3.2-1.5,3.6c0.3,0.9,2.7,3.5,2.7,3.5l0,0V182.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M84.1,182.1v-6.2l0,0c0,0,2.4-2.6,2.7-3.5c0.1-0.4-0.6-2-1.5-3.6L92,165l0,0c2,3.8,3.6,7.3,3.3,8.5 c-0.5,1.5-4.5,5-7.5,7.4C86.6,181.2,85.4,181.6,84.1,182.1L84.1,182.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M69.8,172.3H57.2V172c0.1-2.5-0.2-7.7-0.2-7.7s-1.4,2.3-2.6,4.4l-6.7-3.8l0,0c2.1-3.9,4.6-8.2,6-10.7 c2.6-4.9,12.9-5.8,12.9-5.8s0.5,2.3,3.3,2.9c2.8-0.6,3.3-2.9,3.3-2.9s10.3,1,12.9,5.8c1.3,2.5,3.9,6.7,6,10.7l0,0l-6.7,3.8 c-1.2-2.1-2.6-4.4-2.6-4.4s-0.3,5.2-0.2,7.7v0.2H70h-0.2V172.3z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M62.3,137.3c-0.1-0.1-0.5-0.7-0.4-1.5c0.1-1.1,0.8-1.6,0.8-1.7c0-0.1-0.2-0.4-0.1-0.9 c0.1-0.4,0.4-0.7,0.7-0.7c0-0.1-0.3-1,0.2-1.8c0.4-0.7,1.2-1,1.9-0.7c0.1-0.9,0.5-1.7,1.2-2c0.9-0.5,1.8,0.1,1.9,0.2 c0,0,0.2-0.5,0.6-0.6c0.3-0.1,0.6,0.1,0.8,0.4c0.2-0.3,0.5-0.4,0.8-0.4c0.5,0.1,0.6,0.6,0.6,0.6c0.1-0.1,0.9-0.7,1.9-0.2 c0.7,0.4,1.1,1.1,1.2,2c0.7-0.3,1.5,0,1.9,0.7c0.5,0.8,0.2,1.7,0.2,1.8c0.3,0.1,0.6,0.4,0.7,0.7c0.1,0.4,0,0.8-0.1,0.9 c0.1,0.1,0.8,0.6,0.8,1.7c0,0.8-0.3,1.4-0.4,1.5c0.3,0.2,0.4,0.6,0.3,1s-0.4,0.6-0.7,0.6c-0.1,0.1-0.2,0.2-0.3,0.3 c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1,0-0.3-0.2-0.5-0.4c-0.3-0.6-0.1-1.2,0-1.3c-0.1-0.1-0.7-0.9-0.6-1.9c0-0.2,0.1-0.4,0.2-0.6 c-0.1-0.1-0.9-0.4-1.1-1.3c-0.1-0.3-0.1-0.5-0.1-0.7c-0.2,0.2-0.5,0.2-0.7,0c-0.2-0.1-0.2-0.3-0.3-0.4 c-0.2,0.1-0.6,0.3-1.2,0.3c-0.6-0.1-1-0.4-1.2-0.6c0,0-0.2,0.6-1.1,0.6l0,0l0,0l0,0l0,0c-0.9,0-1.1-0.6-1.1-0.6 c-0.1,0.1-0.6,0.5-1.2,0.6s-1-0.2-1.2-0.3c0,0.1-0.1,0.3-0.3,0.4c-0.2,0.2-0.5,0.2-0.7,0c0,0.2,0,0.4-0.1,0.7 c-0.2,0.9-1,1.2-1.1,1.3c0.1,0.2,0.1,0.4,0.2,0.6c0.1,1-0.5,1.8-0.6,1.9c0,0,0.3,0.7,0,1.3c-0.2,0.3-0.4,0.4-0.5,0.4 s-0.2,0-0.3-0.1s-0.3-0.2-0.3-0.3c-0.3,0-0.6-0.2-0.7-0.6C61.9,138,62.1,137.6,62.3,137.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M82.1,198.9c0,0-34.1-3-37.6-10.5c-2.5-5.5,2.9-9.9,9.1-7.7s28.6,13.1,28.6,13.1L82.1,198.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M84.2,194.8v4.4c0,0,5.8,0.4,6.2-0.3c0.4-0.7,0.8-3-0.7-4.1C88.3,193.7,84.7,193.6,84.2,194.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "82,193.9 84.3,194.8 84.3,199.2 81.9,198.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M57.7,198.9c0,0,34.1-3,37.6-10.5c2.5-5.5-2.9-9.9-9.1-7.7s-28.6,13.1-28.6,13.1L57.7,198.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "57.7,193.9 55.4,194.8 55.4,199.2 57.8,198.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M55.5,194.8v4.4c0,0-5.8,0.4-6.2-0.3s-0.8-3,0.7-4.1C51.4,193.7,55,193.6,55.5,194.8z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M290.7,194.6l-0.3-0.2c-23.9-10-24.4-45.4-24.4-47v-1.1l24.7-8.7l0.5-0.2l25.2,8.9v1.1 c0,1.5-0.6,37.1-24.6,47l-0.3,0.1L290.7,194.6L290.7,194.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M291.3,175.1c-6,0-11-4.7-11.3-10.7c0-0.1,0-0.3,0-0.4c0-0.1,0-0.2,0-0.3c0-0.3,0-0.5,0-0.8h6.1l0.6,1.4 l2.9,6.9c0.3,0.7,0.9,1.1,1.7,1.1h0.1c0.8,0,1.4-0.4,1.7-1.1l3.4-7l0.7-1.4h7.6v-0.4c0-0.5-0.1-1-0.2-1.4 c-0.1-0.5-0.2-1-0.4-1.4c0-0.1-0.1-0.2-0.1-0.3c-1.9-5.5-7-9.2-12.8-9.2s-10.9,3.7-12.8,9.2h2.3c1.8-4.2,5.9-7,10.5-7 s8.7,2.8,10.5,7c0.1,0.2,0.1,0.3,0.2,0.5c0.1,0.3,0.2,0.6,0.3,0.9h-5.2c-0.7,0-1.4,0.4-1.7,1.1l-1.2,2.5l-2.7,5.6l-2.4-5.6 l-1-2.5c-0.3-0.7-1-1.1-1.8-1.1h-8.1l-0.1,0.3c-0.1,0.5-0.2,1-0.2,1.4s-0.1,0.8-0.1,1.2c0,0.1,0,0.2,0,0.3s0,0.3,0,0.4 c0.2,3.4,1.6,6.6,4,8.9c2.5,2.5,5.9,3.9,9.4,3.9c3.6,0,6.9-1.4,9.4-3.9c2.4-2.4,3.9-5.6,4-8.9h-2.2 C302.3,170.4,297.3,175.1,291.3,175.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M291.2,139.1l23.6,8.3c0,0-0.3,35.9-23.6,45.5l0,0c0,0,0,0-0.1,0c-23.2-9.7-23.5-45.5-23.5-45.5 L291.2,139.1L291.2,139.1 M291.2,135.7l-1,0.4h-0.1l0,0l0,0l-23.5,8.3l-2.2,0.8v2.3c0,1.5,0.6,37.8,25.2,48.4l0.6,0.4h1h0.6 l0.6-0.2c25-10.4,25.6-46.9,25.6-48.5v-2.3l-2.2-0.8l-23.6-8.3L291.2,135.7L291.2,135.7z"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_16_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M234.8,116.4c-3.3,1.2-2.3,5.9-2.3,5.9c-1.9,1-4.2-0.8-4.2-0.8l0,0c0.8,1.6,1.4,2.8,1.8,3.2 c0.6,0.5,1.7,1.5,3.1,2.7c0.2,0.2,0.4,0.4,0.6,0.5c2.9-1.6,4.2-1.3,9-1.6c4.9-0.3,6.8,0.5,6.8-5.8 C249.5,114.1,238.1,115.2,234.8,116.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M233.8,128c0,0-0.1,0-0.1,0.1l-0.5-0.6C233.3,127.6,233.5,127.8,233.8,128z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M241.9,183.6v13c0,1.5-1.2,2.7-2.7,2.7h-11.3c-1.5,0-2.7-1.2-2.7-2.7v-10.9h12.5c1.9,0,3.5-1.1,4.3-2.7 C241.9,183.2,241.9,183.4,241.9,183.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M236.6,132.7c0,0,5.2,3,3.4,12c0,0-18.9,5.6-31.9,4.7l0,0c3.8-3.8,5.3-9,5.6-10.1c0-0.1,0-0.2,0-0.2 C229.1,137.8,236.6,132.7,236.6,132.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M234.7,165.6c0.2,1.6-0.1,4.8-2.8,7.2s-14.2,2.5-14.2,2.5c-4.7-5.2-4.5-9.4-4.5-9.4l0,0L234.7,165.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_17_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M108.7,116.4c3.3,1.2,2.3,5.9,2.3,5.9c1.9,1,4.2-0.8,4.2-0.8l0,0c-0.8,1.6-1.4,2.8-1.8,3.2 c-0.6,0.5-1.7,1.5-3.1,2.7c-0.2,0.2-0.4,0.4-0.6,0.5c-2.9-1.6-4.2-1.3-9-1.6c-4.9-0.3-6.8,0.5-6.8-5.8 C93.9,114.1,105.4,115.2,108.7,116.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M109.7,128c0,0,0.1,0,0.1,0.1l0.5-0.6C110.1,127.6,109.9,127.8,109.7,128z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M171.7,127.4c52.4,0,58.3-2.7,58.3-2.7c-0.4-0.4-1-1.5-1.8-3.2c-3.4-7.2-9.9-23.9-12.6-26.6 c-3.3-3.3-43.6-4.1-43.9-4.1l0,0l0,0l0,0l0,0c-0.3,0-40.7,0.8-43.9,4.1c-2.7,2.7-9.2,19.4-12.6,26.6c-0.8,1.6-1.4,2.8-1.8,3.2 C113.4,124.7,119.3,127.4,171.7,127.4L171.7,127.4L171.7,127.4L171.7,127.4L171.7,127.4z M119.5,121.2 c-0.4-1,8.1-20.8,10.5-23.1c2.3-2.2,41.6-3.3,41.7-3.3c0.1,0,39.4,1.1,41.7,3.3c2.4,2.2,10.9,22,10.5,23.1 c-0.4,1-49.1,0.1-52.2,0l0,0l0,0l0,0l0,0C168.6,121.3,119.9,122.2,119.5,121.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M101.6,183.6v13c0,1.5,1.2,2.7,2.7,2.7h11.3c1.5,0,2.7-1.2,2.7-2.7v-10.9h-12.5c-1.9,0-3.5-1.1-4.3-2.7 C101.6,183.2,101.6,183.4,101.6,183.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M240.8,181.4c-0.8,0.8-2,1.3-3.2,1.3h-12.3h-53.5l0,0h-53.5H106c-1.2,0-2.4-0.5-3.2-1.3 c-0.9-0.9-1.5-2.1-1.5-3.5v3c0,0.8,0.2,1.5,0.5,2.1c0.8,1.6,2.4,2.7,4.3,2.7h12.5H172l0,0h53.4h12.5c1.9,0,3.5-1.1,4.3-2.7 c0.3-0.6,0.5-1.3,0.5-2.1v-3C242.3,179.3,241.7,180.5,240.8,181.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M106.8,132.7c0,0-5.2,3-3.4,12c0,0,18.9,5.6,31.9,4.7l0,0c-3.8-3.8-5.3-9-5.6-10.1c0-0.1,0-0.2,0-0.2 C114.3,137.8,106.8,132.7,106.8,132.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M108.7,165.6c-0.2,1.6,0.1,4.8,2.8,7.2c2.7,2.4,14.2,2.5,14.2,2.5c4.7-5.2,4.5-9.4,4.5-9.4l0,0 L108.7,165.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M213.4,98.1c-2.3-2.2-41.5-3.3-41.7-3.3l0,0l0,0l0,0l0,0c-0.2,0-39.4,1.1-41.7,3.3 c-2.4,2.2-10.9,22-10.5,23.1c0.4,1,49.1,0.1,52.2,0c3.1,0.1,51.8,1,52.2,0C224.3,120.2,215.8,100.4,213.4,98.1z"
  }), /*#__PURE__*/React.createElement("pattern", {
    id: "SVGID_4_",
    xlinkHref: "#SVGID_3_",
    patternTransform: "matrix(9.9242 0 0 -9.9242 138032.4375 -161003.1406)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M213.4,98.1c-2.3-2.2-41.5-3.3-41.7-3.3l0,0l0,0l0,0l0,0c-0.2,0-39.4,1.1-41.7,3.3 c-2.4,2.2-10.9,22-10.5,23.1c0.4,1,49.1,0.1,52.2,0c3.1,0.1,51.8,1,52.2,0C224.3,120.2,215.8,100.4,213.4,98.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M242.3,138.2c0-1.8-0.8-3.6-2.2-4.8c-1.8-1.5-4.2-3.6-6.4-5.5c0,0-0.1,0-0.1,0.1l-0.5-0.6 c-1.4-1.2-2.5-2.2-3.1-2.7c0,0-5.9,2.7-58.3,2.7s-58.4-2.7-58.4-2.7c-0.6,0.5-1.7,1.5-3.1,2.7l-0.5,0.6c0,0-0.1,0-0.1-0.1 c-2.1,1.8-4.6,4-6.4,5.5c-1.4,1.2-2.2,2.9-2.2,4.8v18.6v21.1c0,1.4,0.6,2.6,1.5,3.5c0.8,0.8,2,1.3,3.2,1.3H118h53.5l0,0H225 h12.3c1.2,0,2.4-0.5,3.2-1.3c0.9-0.9,1.5-2.1,1.5-3.5v-21.1l0,0v-18.6H242.3z M213.9,139.3c0-0.1,0-0.2,0-0.2 c15.2-1.3,22.7-6.4,22.7-6.4s5.2,3,3.4,12c0,0-18.9,5.6-31.9,4.7l0,0C212,145.5,213.6,140.3,213.9,139.3z M106.8,132.7 c0,0,7.5,5.1,22.7,6.4c0,0,0,0.1,0,0.2c0.3,1,1.9,6.2,5.6,10.1l0,0c-13,0.9-31.9-4.7-31.9-4.7 C101.6,135.7,106.8,132.7,106.8,132.7z M125.7,175.3c0,0-11.5-0.1-14.2-2.5s-3-5.6-2.8-7.2l21.5,0.2l0,0 C130.2,165.9,130.4,170.1,125.7,175.3z M180,161.7c0.9,0,1.9,0,3,0C182,161.7,181,161.7,180,161.7z M186.4,161.8 c0.4,0,0.8,0,1.2,0C187.2,161.8,186.8,161.8,186.4,161.8z M231.9,172.8c-2.7,2.4-14.2,2.5-14.2,2.5c-4.7-5.2-4.5-9.4-4.5-9.4 l0,0l21.5-0.2C234.9,167.2,234.6,170.4,231.9,172.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M194.6,149.1h-45.8c-2.1,0-3.8-1.7-3.8-3.8l0,0c0-2.1,1.7-3.8,3.8-3.8h45.8c2.1,0,3.8,1.7,3.8,3.8l0,0 C198.5,147.4,196.7,149.1,194.6,149.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M197,178.5h-50.6c-4.4,0-7.9-3.5-7.9-7.9v-3.7c0-1.1,0.9-2,2-2h62.3c1.1,0,2,0.9,2,2v3.7 C204.9,174.9,201.4,178.5,197,178.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M189.2,174.6h-35c-0.9,0-1.6-0.7-1.6-1.6v-1.6c0-0.9,0.7-1.6,1.6-1.6h35c0.9,0,1.6,0.7,1.6,1.6v1.6 C190.9,173.9,190.1,174.6,189.2,174.6z"
  })))))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M237.6,72.6h-2.9l1.6-5.2L237.6,72.6z M233.1,78.4l1-3.4h4l0.9,3.4h3.7L239,65.3c-0.2-0.8-0.7-1.1-1.5-1.1 h-5.2v1.2h0.4c0.5,0,0.8,0.2,0.8,0.6c0,0.3-0.1,0.5-0.3,1.2l-3.7,11.2C229.5,78.4,233.1,78.4,233.1,78.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M247.2,78.4V65.3c0-0.7-0.4-1.1-1-1.1H243v1.2h0.2c0.5,0,0.8,0.2,0.8,0.8v12.2H247.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M252.9,78.4V65.3c0-0.7-0.4-1.1-1-1.1h-3.2v1.2h0.2c0.5,0,0.8,0.2,0.8,0.8v12.2H252.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M258.6,65.5c0-0.9-0.7-1.5-1.8-1.5c-1.1,0-1.8,0.6-1.8,1.5s0.7,1.5,1.8,1.5C257.9,67,258.6,66.4,258.6,65.5z  M258.6,78.4v-9.7c0-0.7-0.4-1.1-1-1.1h-3.2v1.3h0.2c0.5,0,0.8,0.3,0.8,0.8v8.6L258.6,78.4L258.6,78.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M265.9,73.3v2c-0.6,0.6-1.2,0.9-1.8,0.9c-0.6,0-0.8-0.3-0.8-1.1c0-0.8,0.2-1.1,0.8-1.4 C264.5,73.6,265.1,73.4,265.9,73.3z M261.5,70.8c1.1-0.5,2.3-0.8,3.2-0.8c0.9,0,1.2,0.3,1.2,1.3v0.2c-1.3,0.2-1.7,0.3-2.5,0.5 c-0.4,0.1-0.8,0.2-1.2,0.4c-1.3,0.5-1.9,1.6-1.9,3.2c0,2,0.8,3,2.6,3c0.6,0,1.2-0.1,1.7-0.3c0.5-0.2,0.7-0.4,1.4-0.9v0.1 c0,0.7,0.3,1,1,1h3v-1.2h-0.1c-0.6,0-0.8-0.2-0.8-0.9v-5c0-2.7-0.9-3.6-3.6-3.6c-0.9,0-1.7,0.1-2.5,0.3c-0.8,0.2-1.2,0.4-2.2,0.9 L261.5,70.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M275,78.4v-7.2c0.6-0.6,1.2-0.9,1.9-0.9c0.7,0,0.9,0.3,0.9,1.3v6.8h3.2V71c0-1.7-0.1-2.2-0.7-2.8 c-0.4-0.5-1.1-0.8-2-0.8c-1.3,0-2.2,0.4-3.5,1.6v-0.4c0-0.7-0.3-1.1-1-1.1h-3.1v1.3h0.2c0.5,0,0.8,0.3,0.8,0.8v8.6h3.3V78.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M290.9,76.2h-4.6l4.3-6.2v-2.2h-6.9c-0.8,0-1.1,0.4-1.1,1.1v1.9h1.3v-0.2c0-0.5,0.3-0.7,0.8-0.7h2.3l-4.4,6.3 v2.1h8.2v-2.1H290.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M308.4,77.7V65.9c0-0.9-0.3-1.3-1.2-1.3h-2.7v1.3h0.2h0.3c0.1,0,0.2,0.1,0.3,0.1c0.1,0.1,0.2,0.3,0.2,0.6v11 L308.4,77.7L308.4,77.7z M309.9,77.7h3v-9c0-0.9-0.3-1.3-1.2-1.3h-1.8V77.7z M304.1,77.7V67.5h-1.8c-0.9,0-1.2,0.4-1.2,1.3v9h3 V77.7z M315.9,71.7c0,5.4-3.8,9.3-9,9.3s-9-3.9-9-9.3c0-5.3,3.8-9.2,9-9.2C312.1,62.4,315.9,66.3,315.9,71.7z M318.1,71.7 c0-6.5-4.8-11.4-11.2-11.4c-6.4,0-11.2,4.9-11.2,11.4s4.8,11.4,11.2,11.4C313.3,83.1,318.1,78.2,318.1,71.7z"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAllianz, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/allianz.0a2de77b.svg";
export { ForwardRef as ReactComponent };